// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1HYMS","select":"Header_select__3cXQ7","clinic":"Header_clinic__10i6E"};